import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { ResidentialService } from './residential.service';
import { _ } from 'underscore';
import { AddComponent } from './add-component';
import { RQ1Component } from './residential-question/r-q1/r-q1.component';
import { RQ2Component } from './residential-question/r-q2/r-q2.component';
import { RQ3Component } from './residential-question/r-q3/r-q3.component';
import { RQ4Component } from './residential-question/r-q4/r-q4.component';
import { RQ5Component } from './residential-question/r-q5/r-q5.component';
import { RQ6Component } from './residential-question/r-q6/r-q6.component';
import { RQ7Component } from './residential-question/r-q7/r-q7.component';
import { RQ8Component } from './residential-question/r-q8/r-q8.component';
import { RQ9Component } from './residential-question/r-q9/r-q9.component';
import { RQ10Component } from './residential-question/r-q10/r-q10.component';
import { RQ11Component } from './residential-question/r-q11/r-q11.component';
import { RQ12Component } from './residential-question/r-q12/r-q12.component';
import { RQ13Component } from './residential-question/r-q13/r-q13.component';
import { RQ14Component } from './residential-question/r-q14/r-q14.component';
import { RQ15Component } from './residential-question/r-q15/r-q15.component';
import { RQ16Component } from './residential-question/r-q16/r-q16.component';
import { RQ17Component } from './residential-question/r-q17/r-q17.component';
import { RQ18Component } from './residential-question/r-q18/r-q18.component';
import { RQ19Component } from './residential-question/r-q19/r-q19.component';
import { RQ20Component } from './residential-question/r-q20/r-q20.component';
import { RQ21Component } from './residential-question/r-q21/r-q21.component';
import { RQ22Component } from './residential-question/r-q22/r-q22.component';
import { RQ23Component } from './residential-question/r-q23/r-q23.component';
import { RQ24Component } from './residential-question/r-q24/r-q24.component';
import { RQ25Component } from './residential-question/r-q25/r-q25.component';
import { RQ26Component } from './residential-question/r-q26/r-q26.component';
import { RQ27Component } from './residential-question/r-q27/r-q27.component';
import { RQ28Component } from './residential-question/r-q28/r-q28.component';
import { RQ29Component } from './residential-question/r-q29/r-q29.component';
import { RQ30Component } from './residential-question/r-q30/r-q30.component';
import { RQ31Component } from './residential-question/r-q31/r-q31.component';
// import { QuestionarieSignupModule } from '../questionarie-signup.module';
import { questions} from '../../../assets/questionnaire';


@Component({
  selector: 'app-questionnaire-residential',
  templateUrl: './questionnaire-residential.component.html',
  styleUrls: ['./questionnaire-residential.component.css']
})
export class QuestionnaireResidentialComponent implements OnInit, OnDestroy {

  questions: AddComponent[];
  ques;
  resQues: AddComponent[] = [];
  deviceWidth;
  components = [RQ1Component, RQ2Component, RQ3Component, RQ4Component, RQ5Component, 
    // RQ6Component,
    RQ7Component, RQ8Component, RQ9Component, RQ10Component, RQ11Component, RQ12Component, RQ13Component, RQ14Component
    , RQ15Component, RQ16Component, RQ17Component, RQ18Component, RQ19Component, RQ20Component, RQ21Component,
    RQ22Component, RQ23Component, RQ24Component, RQ26Component, RQ27Component, RQ28Component, RQ29Component,
    RQ30Component, RQ31Component];

  constructor(public residentialService: ResidentialService) {
    this.deviceWidth = window.innerWidth;
    this.residentialService.deviceWidth = this.deviceWidth;
    localStorage.setItem('deviceWidth', this.deviceWidth);
    let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    sessionStorage.setItem('browserType', JSON.stringify(isIEOrEdge));
  }

  ngOnInit() {
    // this.residentialService.getQuestions().subscribe(response => {
    //   this.ques = response;
    
    this.ques = questions;
      this.residentialService.setQuestions(questions);
      for (let i = 0; i < this.ques.length; i++) {
        this.resQues.push(new AddComponent(this.components[i], this.ques[i]._id));
      }
      this.questions = this.resQues;
    // });
    // this.residentialService.getQuestions().subscribe(response =>{
    //   this.ques = response;
    //   for (let i= 0; i<this.ques.length; i++){
    //    this.resQues.push(new AddComponent(this.components[i], this.ques[i]));
    //   }
    //   this.questions = this.resQues;
    //   // console.log.log(this.questions);
    // })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.deviceWidth = event.target.innerWidth;
    this.residentialService.deviceWidth = this.deviceWidth;
    localStorage.setItem('deviceWidth', this.deviceWidth);
  }

  ngOnDestroy() {
    // localStorage.removeItem('userResponse');
  }

}
